import React, { useState } from "react"
import Heading from "./Heading";
import { IMapProps, Map } from "../Search/Map";
import { GoogleMapProps, MarkerProps } from "@react-google-maps/api";
import { IListing } from "../../lib";


export interface IMapBladeProps {
    className?: string;
    title?: string;
    titleHeadingLevel?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p";
    subtitle?: string;
    locations?: IListing[];
    mapProps?: Partial<GoogleMapProps>;
    mapClick?: (arg: any) => void;
    markerProps?: Partial<MarkerProps>;
    mapWrapperProps?: Partial<IMapProps>;
}

export const MapBlade: React.FC<IMapBladeProps> = ({
    className = "",
    title,
    titleHeadingLevel = "h1",
    subtitle,
    locations,
    mapProps,
    mapClick,
    markerProps,
    mapWrapperProps
}) => {


    return (
        <section className={`${className} map-blade flex items-center justify-center flex-col`}>
            {(title || subtitle) && (
                <div className="w-full pb-10">
                    {title && (
                        <Heading className="text-center py-0" headingLevel={titleHeadingLevel}>{title}</Heading>
                    )}
                    {subtitle && (
                        <div className="flex flex-row flex-nowrap items-center italic pt-2">
                            <div className="w-20 border-t border-solid"></div>
                            <span className="pl-3 text-xl">{subtitle}</span>
                        </div>
                    )}
                </div>
            )}
            <div className="w-full">
                <Map
                    extraLocations={locations}
                    mapProps={mapProps}
                    mapClick={mapClick}
                    markerProps={markerProps}
                    {...mapWrapperProps}
                />
            </div>
        </section>
    )
}

export default MapBlade